module.exports = __webpack_public_path__ + "static/media/puzzle-23-bg.14307615.svg";